export const checkTerminalMode = (config, mode) => (
  !config.main.terminalMode || config.main.terminalMode === mode
);

export const normalizeAlias = (alias) => alias?.toLowerCase().replace(/\s/g, "");

export const sleep = (seconds) => new Promise((resolve) => {
  setTimeout(() => resolve(), seconds * 1000);
});

export const addSpaceBeforeEachCapital = (text) => text?.replace(/([A-Z])/g, ' $1').trim();